import { Classes, Icon, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import CX from 'classnames'
import * as React from 'react'
import { showToast } from '../../Toast'
import { UprightStyle } from '../../types'
import { copyToClipboard } from '../../utils'

interface Props {
  value: string
  toastValue?: string
  className?: string
  hideText?: boolean
  iconSize?: number
  color?: string
}

export async function copyAndToast(value, displayValue) {
  await copyToClipboard(value)
  showToast(`Copied ${displayValue || value} to clipboard`, Intent.SUCCESS, false)
}

const styles: UprightStyle = {
  mouse: { cursor: 'pointer' },
  dupIcon: { marginLeft: 5, marginBottom: 3 }
}

export const CopySnippet: React.FC<Props> = ({ value, toastValue, className, hideText, iconSize = 10, color }) => {
  const onClick = React.useCallback(
    async (e: React.MouseEvent<HTMLSpanElement>) => {
      e.stopPropagation()
      await copyAndToast(value, toastValue || value)
    },
    [value, toastValue]
  )
  return (
    <span
      onClick={onClick}
      role="application"
      style={styles.mouse}
      className={className || CX(Classes.TEXT_MUTED, 'copy-snippet')}
    >
      {hideText ? '' : value}
      <Icon style={styles.dupIcon} icon={IconNames.DUPLICATE} size={iconSize} color={color} />
    </span>
  )
}
